import {Component, Element, State, h, Prop} from '@stencil/core';

@Component({
  tag: 'uiaas-search-widget-hear-from-customer',
  styleUrl: 'hear-from-customer-widget.scss',
  shadow: true
})
export class HearFromCustomerWidget {

  @Prop() readonly country: string = 'us';
  @Prop() readonly language: string = 'en';
  @Prop() readonly link: string;
  @Prop() readonly appName: string;
  @Prop() readonly anchorTarget: string = '';

  @Element()
    el: HTMLElement;

  @State()
    tabName: string;

  private makeLabel() {
      const language = this.language.toLowerCase();

      switch (language) {
      default:
      case 'en':
        return ['Hear from our Customers', 'Discover how our customers, make the most of their energy and resources.', 'Explore now'];
      case 'de':
        return ['Erfahren Sie mehr von unseren Kunden', 'Erfahren Sie, wie unsere Kunden ihre Energie und Ressourcen optimal nutzen können', 'Jetzt entdecken'];
      case 'pl':
        return ['Posłuchaj naszych klientów', 'Dowiedz się, jak nasi klienci w pełni wykorzystują swoją energię i zasoby', 'Dowiedz się więcej'];
      case 'fr':
        return ['Écoutez nos clients', 'Découvrez comment nos clients tirent le meilleur parti de leur énergie et de leurs ressources', 'Découvrir maintenant'];
      case 'ru':
        return ['Связь с нашими клиентами', 'Узнайте, как наши клиенты максимально эффективно используют энергию и ресурсы', 'Узнать больше'];
      case 'nl':
        return ['Luister naar onze klanten', 'Ontdek hoe onze klanten hun energie en middelen optimaal benutten', 'Ontdek nu'];
      case 'it':
        return ['Ascolta i nostri clienti', 'Scopri in che modo i nostri clienti possono sfruttare al massimo le loro risorse energetiche', 'Esplora ora'];
      case 'sv':
        return ['Hör från våra kunder', 'Upptäck hur våra kunder får ut mesta möjliga av sin energi och sina resurser', 'Utforska nu'];
      case 'es':
        return ['Escucha a nuestros clientes', 'Descubre cómo nuestros clientes aprovechan al máximo su energía y sus recursos', 'Explora ahora'];
      case 'ja':
        return ['当社のお客様がエネルギーとリソースをどのように最大限に活用しているかを紹介します。', '当社のお客様がエネルギーとリソースをどのように最大限に活用しているかを紹介します。', '詳細はこちら'];
      case 'zh':
        return ['客户心声', '了解我们的客户如何充分利用其能源和资源', '即刻了解'];
      case 'fi':
        return ['Kuuntele asiakkaitamme', 'Lue, miten asiakkaamme hyödyntävät energiansa ja resurssinsa parhaalla mahdollisella tavalla.', 'Tutustu nyt'];
      }
  }

  private getLink(): string {
      const supportLink = this.link ? this.link : `https://www.se.com/${this.country}/${this.language}/work/campaign/life-is-on/life-is-on.jsp`;
  
      return supportLink;
  }

  connectedCallback() {
      const closestTabEl = this.el.closest('uiaas-search-tab');
      this.tabName = closestTabEl?.['tabName'];
  }

  render() {
      const labels = this.makeLabel();
      const link = this.getLink();
      return <uiaas-search-cta-widget-v2
        anchor-target={this.anchorTarget}
        tab-name= {this.tabName}
        event-category="Hear from our Customers"
        header={labels[0]}
        content={labels[1]}
        url={link}
        buttonText={labels[2]}
      >
        <qds-icon
          slot="icon"
          size="large" 
          name="persons"
          className="dashboard-widget-icon"
        />
      </uiaas-search-cta-widget-v2>;
  }
}
